import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const dismissPopupsButtonStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: "flex",
            justifyContent: "end",
        },

        button: {
            width: "100px",
            background: "white",
            border: "1px solid rgba(0, 0, 0, 0.23)",
            color: "#616161",
            boxShadow:
                "0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05)",

            "&:hover": {
                background: theme.colors.feedback.errorBackground,
                color: theme.colors.feedback.error,
                borderColor: theme.colors.feedback.error,
            },
        },
    })
);
